
import NavBar from './NavBar.vue'
import NavBtn from './NavBtn.vue'
export default {
  name: 'NavAll',
  components: {
    NavBar,
    NavBtn
  }
}
